import * as React from 'react';
import { Avatar, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { VirtualProviderTeamDto } from '../../models/dtos/VirtualProviderCatalogDto';

export default function VirtualTeamsTable(props: {
    teams: VirtualProviderTeamDto[];
    sportNames: Map<number, string>;
    onTeamClick?: (team: VirtualProviderTeamDto) => void;
}) {
    if (props.teams.length === 0) return <Typography color="text.secondary">No teams found.</Typography>;
    return (
        <TableContainer>
            <Table size="small">
                <TableHead><TableRow>
                    <TableCell>Team</TableCell><TableCell>Sport</TableCell><TableCell>Country</TableCell><TableCell>Status</TableCell><TableCell>Biography</TableCell><TableCell>Created</TableCell>
                </TableRow></TableHead>
                <TableBody>{props.teams.map(team => (
                    <TableRow key={team.id} hover onClick={() => props.onTeamClick?.(team)} sx={props.onTeamClick ? { cursor: 'pointer' } : undefined}>
                        <TableCell>
                            <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                <Avatar src={team.imageUrl ?? undefined} sx={{ width: 32, height: 32 }}>{team.name.slice(0, 1)}</Avatar>
                                <span><Typography variant="body2">{team.name}</Typography><Typography variant="caption" color="text.secondary">{team.id}</Typography></span>
                            </span>
                        </TableCell>
                        <TableCell>{props.sportNames.get(team.sportId) ?? `Sport ${team.sportId}`}</TableCell>
                        <TableCell>{team.originCountry || '—'}</TableCell>
                        <TableCell><Chip size="small" color={team.active ? 'success' : 'default'} label={team.active ? 'Active' : 'Inactive'} /></TableCell>
                        <TableCell sx={{ maxWidth: 480 }}><Typography variant="body2" noWrap title={team.biography}>{team.biography}</Typography></TableCell>
                        <TableCell>{new Date(team.createdAt).toLocaleString()}</TableCell>
                    </TableRow>
                ))}</TableBody>
            </Table>
        </TableContainer>
    );
}
